<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <ndt-register-quick-filter>
      <div class="banned-ip-filter-form">
         <ndt-date-filter
            [fromDate]="startDate"
            [toDate]="endDate"
            [dateRangePickerOptions]="dateRangePickerOptions"
            [initialContentFormValue]="initialDateRange"
            (logQuickFilterChanged)="onDateQuickFilterChange($event)"
            class="date-filter"
         ></ndt-date-filter>

         <mat-form-field class="banned-ip-type-filter">
            <mat-label>Type</mat-label>
            <input
               autocomplete="off"
               type="text"
               [ngModel]="selectedBlockedIpType"
               (ngModelChange)="onTypeSelected($event)"
               id="blockedIpType"
               lcsStaticSelect
               [lcsSingleSelect]="blockedIpTypeSelect"
               [lcsStaticSelectValue]="selectedBlockedIpType"
            />
            <lcs-static-select
               #blockedIpTypeSelect
               [displayWith]="blockedIpTypeDisplayWith"
               [isIncludeEmptyOption]="true"
            >
               <lcs-option [value]="null">{{ '' }}</lcs-option>
               @for (blockedIpType of blockedIpTypes; track blockedIpType) {
               <lcs-option [value]="blockedIpType">
                  {{ blockedIpTypeDisplayWith(blockedIpType) }}
               </lcs-option>
               }
            </lcs-static-select>
         </mat-form-field>

         <mat-form-field class="banned-ip-status-filter">
            <mat-label>Status</mat-label>
            <input
               autocomplete="off"
               type="text"
               [ngModel]="selectedBlockedIpStatus"
               (ngModelChange)="onStatusSelected($event)"
               id="blockedIpStatus"
               lcsStaticSelect
               [lcsSingleSelect]="blockedIpStatusSelect"
               [lcsStaticSelectValue]="selectedBlockedIpStatus"
            />
            <lcs-static-select
               #blockedIpStatusSelect
               [displayWith]="blockedIpStatusDisplayWith"
               [isIncludeEmptyOption]="true"
            >
               <lcs-option [value]="null">{{ '' }}</lcs-option>
               @for (blockedIpStatus of blockedIpStatuses; track blockedIpStatus) {
               <lcs-option [value]="blockedIpStatus">
                  {{ blockedIpStatusDisplayWith(blockedIpStatus) }}
               </lcs-option>
               }
            </lcs-static-select>
         </mat-form-field>
      </div>
   </ndt-register-quick-filter>

   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="type" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-type-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="type"
               >Type<mat-icon class="mat-icon-sort">{{ getSort('type') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let bannedIp">{{ blockedIpTypeDisplayWith(bannedIp.type) }}</td>
         </ng-container>
         <ng-container lcsColumnDef="ipAddress" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-address-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="ipAddress"
               >IP Address<mat-icon class="mat-icon-sort">{{ getSort('ipAddress') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let bannedIp">
               {{ bannedIp.ipAddress }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="firstSeen" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-first-seen-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="firstSeen"
               >First Seen<mat-icon class="mat-icon-sort">{{ getSort('firstSeen') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let bannedIp">
               {{ bannedIp.firstSeen | date : 'MM/dd/yyyy hh:mm aa' : 'UTC' }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="updateDate" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-update-date-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Desc"
               sortField="updateDate"
               >Update Date<mat-icon class="mat-icon-sort">{{ getSort('updateDate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let bannedIp">
               {{ bannedIp.updateDate | date : 'MM/dd/yyyy hh:mm aa' : 'UTC' }}
            </td>
         </ng-container>
         <ng-container lcsColumnDef="status" width="1">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-status-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [attr.sortDirection]="getOrderingOption(orderingOptions, 'statusName')"
               sortField="statusName"
               >Status<mat-icon class="mat-icon-sort">{{ getSort('statusName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let bannedIp">{{ blockedIpStatusDisplayWith(bannedIp.status) }}</td>
         </ng-container>
         <ng-container lcsColumnDef="bannedIpActionsMenu" width="0.25">
            <th lcs-header-cell *lcsHeaderCellDef id="banned-ip-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let bannedIp">
               @if (canUnbanOrAllow(bannedIp)) {
               <button
                  type="button"
                  aria-label="Banned IP Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="bannedIpMenu"
                  [disabled]="disabled"
                  id="device-detail-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               }
               <mat-menu #bannedIpMenu="matMenu">
                  @if (canUnbanOrAllow(bannedIp)) {
                  <button mat-menu-item type="button" id="banned-ip-unban" (click)="onUnbanClick(bannedIp)">
                     Unban
                  </button>
                  } @if (canUnbanOrAllow(bannedIp)) {
                  <button mat-menu-item type="button" id="banned-ip-allow" (click)="onAllowClick(bannedIp)">
                     Allow
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
